import ErrorPage from '../../status-pages/components/ErrorPage';

// TODO: Add PriceLockPage logic as per figma in DSO-1431
const PriceLockPage = () => {
  return <ErrorPage />;
};

export default PriceLockPage;
